<template>
    <v-card flat tile :class="{'light': !transparent, 'transparent': transparent}" 
        class="ma-2 ">
    <v-card-text class="comment-border-left py-0" >
         
       <p class="mb-2" v-html="comment.text"></p> 
         <span v-if="comment.tags">
            <v-chip outlined dense small class="ma-1" v-for="(t,i) in comment.tags" :key="i">{{t}}</v-chip>
        </span>
        <div class="darken-1 d-flex mt-2 justify-space-between">
            <sr-person-chip small selectOption  :id="comment.metadata.lastUpdatedBy || comment.metadata.createdBy" class="mx-1"></sr-person-chip>
            <span class="overline">
                <span v-if="!sameDay(comment.metadata.created,comment.metadata.lastUpdated)">
                    Created {{comment.metadata.created | moment("DD MMM YYYY")}}, Updated 
                </span>
                <span>{{comment.metadata.lastUpdated | moment("DD MMM YYYY")}}<span v-if="reviewed && reviewed > comment.metadata.lastUpdated && !sameDay(reviewed, comment.metadata.lastUpdated)">, Reviewed {{reviewed | moment("DD MMM YYYY")}}
                </span>
            </span>
               

            </span>

        </div>
      
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'Comment',
    computed:{
        reviewedDate(){
            return this.reviewed ? new Date(this.reviewed) : null; 
        }
    },
    props: {
        comment:{
            type: Object
        },
        transparent:{
            type: Boolean,
            default: false
        },
        fullWidth:{
            type: Boolean,
            default: false
        },
        reviewed:{
            type: String
        }
    }
}
</script>